/**
 * @generated SignedSource<<9cb04580756d9926598f78f63a717fce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserAdminEditGroupDeviceSetTeamsScreenMutation$variables = {
  id: string;
  teamIds: ReadonlyArray<string>;
};
export type UserAdminEditGroupDeviceSetTeamsScreenMutation$data = {
  readonly store: {
    readonly sharedMobileDevice: {
      readonly setTeams: {
        readonly id: string;
        readonly teams: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }>;
      };
    } | null;
  };
};
export type UserAdminEditGroupDeviceSetTeamsScreenMutation = {
  response: UserAdminEditGroupDeviceSetTeamsScreenMutation$data;
  variables: UserAdminEditGroupDeviceSetTeamsScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "SharedMobileDeviceMutations",
        "kind": "LinkedField",
        "name": "sharedMobileDevice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "teamIds",
                "variableName": "teamIds"
              }
            ],
            "concreteType": "SharedMobileDevice",
            "kind": "LinkedField",
            "name": "setTeams",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAdminEditGroupDeviceSetTeamsScreenMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAdminEditGroupDeviceSetTeamsScreenMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "95b693deb5526a7c9103cea4d01d4d69",
    "id": null,
    "metadata": {},
    "name": "UserAdminEditGroupDeviceSetTeamsScreenMutation",
    "operationKind": "mutation",
    "text": "mutation UserAdminEditGroupDeviceSetTeamsScreenMutation(\n  $id: ID!\n  $teamIds: [ID!]!\n) {\n  store {\n    sharedMobileDevice(id: $id) {\n      setTeams(teamIds: $teamIds) {\n        id\n        teams {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2061a03ae457bd2b3d91f06395818a0";

export default node;
